import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import SetupFeatures from './components/SetupFeatures';

const SetupFeaturesBridge = react2angular(SetupFeatures);
export default SetupFeaturesBridge;
